module.exports = __webpack_public_path__ + "img/quxiaojingyin.82b56951.png";